<template>
<div id="agreementList">
  <div>
    <formCheckBox :name="'ACCEPTANCE_OF_THE_TERMS'" :trueValue="true" :falseValue="false"></formCheckBox>
    <a href="https://finmoll.ru/backend/content/documents/microloan_terms_conditions" target="_blank"> Подробнее</a>
  </div>
  <div>
    <formCheckBox :name="'AGREEMENT_WITH_THE_RULES'" :trueValue="true" :falseValue="false"></formCheckBox>
    <a href="https://finmoll.ru/backend/content/documents/rules_microloans" target="_blank"> Подробнее</a>
  </div>
  <div>
    <formCheckBox :name="'REQURENT_PAY'" :trueValue="true" :falseValue="false"></formCheckBox>
    <a href="https://finmoll.ru/backend/content/documents/agreement_recurring_payments" target="_blank">Открыть документ</a>
  </div>
  <!--          <div>-->
  <!--            <formCheckBox :name="'AGREEMENT_IU'" :trueValue="true" :falseValue="false"></formCheckBox>-->
  <!--            <a :href="links.iuUrl" target="_blank">Открыть документ</a>-->
  <!--          </div>-->
  <div>
    <formCheckBox :name="'AGREEMENT_PDN'" :trueValue="true" :falseValue="false"></formCheckBox>
    <a :href="pdnUrl" target="_blank">Открыть документ</a>
  </div>
  <div>
    <formCheckBox :name="'ASP'" :trueValue="true" :falseValue="false" ></formCheckBox>
    <a href="https://finmoll.ru/documents/soglashenie-ob-ispolzovanii-asp.pdf" target="_blank">Согласие об использовании аналога собственноручной подписи</a>
  </div>
</div>
</template>

<script>
export default {
  name: "agreement",
  props:{
    guid:{
      type:String,
      default:''
    },
  },
  components:{
    formCheckBox: () => import('@/views/pdlloan/formCheckBox'),
  },
  computed:{
    pdnUrl(){
      return 'https://lk.msk.finmoll.com/public/pdnIl/'+this.guid;
    }
  }
}
</script>

<style scoped>
#agreementList{}
#agreementList > div{margin-bottom: 4vw;}
a{display: block;text-align: left}
@media screen and (min-width: 760px) {
  #agreementList{}
  #agreementList > div{margin-bottom: 2vw;}
  a{}
}
@media screen and (min-width: 1240px) {
  #agreementList{}
  #agreementList > div{margin-bottom: 20px;}
  a{}
}
</style>